export default __webpack_public_path__ + "static/media/about-zl-1.7bf35101.jpg";